import { render, staticRenderFns } from "./BarnDocumentationIncident.vue?vue&type=template&id=751f6ed2&scoped=true"
import script from "./BarnDocumentationIncident.vue?vue&type=script&lang=js"
export * from "./BarnDocumentationIncident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751f6ed2",
  null
  
)

export default component.exports